import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import LoyaltyOfferTrendsApiDefinitions from './loyalty-offer-trends-api-definitions/loyalty-offer-trends-api-definitions.component';

type LoyaltyOfferTrendsAPIDetailsDrawerProps = {
  isOpen: boolean;
  close: () => void;
};

const LoyaltyOfferTrendsAPIDetailsDrawer = ({
  isOpen,
  close,
}: LoyaltyOfferTrendsAPIDetailsDrawerProps) => {
  const { t } = useTranslation();
  return (
    <UtilityDrawer
      open={isOpen}
      onClose={close}
      title={t('page.loyaltyPerformanceReport.tabs.loyaltyOfferTrends.label')}
    >
      <UtilityDrawerBody>
        <LoyaltyOfferTrendsApiDefinitions />
      </UtilityDrawerBody>
    </UtilityDrawer>
  );
};

export default LoyaltyOfferTrendsAPIDetailsDrawer;
